export class GetCollections {
  static readonly type = '[Collections] Get collections';

  constructor(public locale: string) {}
}

export class ResetStore {
  static readonly type = '[Collections] Reset store';
}
